import { ATTESTATIONS } from '@src/graphql/queries/attestation';
import { useFetchItems } from 'pe-core-frontend';
export const useAttestations = ({ attestableType, attestableId, userId }) => {
    const { items, error, loading, find } = useFetchItems({
        fetchQuery: ATTESTATIONS,
        dataProp: 'attestations',
        spec: {
            attestableType,
            attestableId,
            userId,
        },
    });
    return {
        attestations: items || [],
        error,
        loading,
        find,
    };
};
